import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { BLOCKCHAINS } from "../../constants/app-enums";
import { CommonApiService } from "src/app/services/common-api-service";
import { API_Const } from "../../constants/apiRouteConst";
import { IPrizeCard } from "src/app/components/lootboxes/lootbox.interface";
import { EventService } from "src/app/services/event.service";

@Component({
  selector: "app-withdraw-nft",
  templateUrl: "./withdraw-nft.component.html",
  styleUrls: ["./withdraw-nft.component.scss"],
})
export class WithdrawNftComponent {
  selectedChain = "ETH";
  walletAddressForm!: FormGroup;
  isConfirmWithdrawalStep: boolean = false;
  selectedNFTs: IPrizeCard[] = [];
  destinationWallet = new FormControl("");
  withdrawalStatus: "SUCCESS" | "ERROR" | "" = "";
  isWithdrawing = false;

  constructor(
    private modalService: BsModalService,
    private apiService: CommonApiService,
    private eventService: EventService
  ) {
    let walletAddressRegex;
    switch (this.selectedChain) {
      case BLOCKCHAINS.ETH ||
        BLOCKCHAINS.POLYGON ||
        BLOCKCHAINS.BSC:
        walletAddressRegex = /^0x[a-fA-F0-9]{40}$/;
        break;
      default:
        walletAddressRegex = /^0x[a-fA-F0-9]{40}$/;
    }

    this.walletAddressForm = new FormGroup({
      walletAddress: new FormControl("", [
        Validators.required,
        Validators.pattern(walletAddressRegex),
      ]),
      confirmWalletAddress: new FormControl("", [
        Validators.required,
        Validators.pattern(walletAddressRegex),
      ]),
    });
    this.walletAddressForm.valueChanges.subscribe((res) => {
      const { walletAddress, confirmWalletAddress } =
        this.walletAddressForm.controls;
      if (walletAddress.valid && confirmWalletAddress.valid) {
        if (walletAddress.value !== confirmWalletAddress.value) {
          confirmWalletAddress.setErrors({ addressMismatch: true });
        }
      } else if (walletAddress.valid) {
        if (walletAddress.value === confirmWalletAddress.value) {
          confirmWalletAddress.updateValueAndValidity();
        }
      }
    });
  }

  close() {
    this.modalService.hide();
  }

  submitAddress() {
    this.isConfirmWithdrawalStep = true;
    this.destinationWallet.setValue(
      this.walletAddressForm.get("walletAddress")!.value
    );
  }

  editAddress() {
    this.isConfirmWithdrawalStep = false;
  }

  confirmWithdraw() {
    this.isWithdrawing = true;
    this.eventService.showSpinner();
    const prize_ids: number[] = [];
    const walletAddress = this.walletAddressForm.get("walletAddress")?.value;
    this.selectedNFTs.forEach((nft: IPrizeCard) => {
      prize_ids.push(nft?.prizeId as number);
    });
    this.apiService
      .post(
        API_Const.lootboxes.nftClaim,
        {
          prize_ids,
          wallet_address: walletAddress,
          wallet_chain: this.selectedChain,
          confirm_wallet_address: walletAddress,
        },
        true
      )
      .subscribe({
        next: () => {
          this.withdrawalStatus = "SUCCESS";
          this.isWithdrawing = false;
          this.eventService.hideSpinner();
        },
        error: () => {
          this.withdrawalStatus = "ERROR";
          this.eventService.hideSpinner();
          this.isWithdrawing = false;
        },
      });
  }
}
